// telegramData.js

// You can adjust this URL to match your actual endpoint
// or have it dynamically pulled from REACT_APP_API_URL
const apiUrl = process.env.REACT_APP_BACKEND_URL || "https://not_set";

export async function fetchTelegramData() {
  try {
    // Note: if the actual endpoint is "api/telegram-data", concatenate it accordingly
    const response = await fetch(`${apiUrl}/api/telegram-data`);
    if (!response.ok) {
      throw new Error(`Failed to fetch. Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching Telegram data:', error);
    throw error;
  }
}
